"use client";


import clsx from "clsx";
import PricingOfferButton from "~/app/[locale]/pricing/components/PricingOfferButton";

import { useTranslation } from "~/app/hooks/useTranslation";
import SectionWrapper from "~/common/components/SectionWrapper";

import styles from "./BookADemoSection.module.scss";

export default function BookADemoSection({ bgImg, locale, children, className }) {
  const { t } = useTranslation(locale);
  const bg = bgImg === undefined ? "/common/book-a-demo-hero.jpg" : bgImg;

  return (
    <SectionWrapper background={bg} className={clsx(className, styles.container)}>
      <div className={styles.layout}>
        <div className={styles.containerContent}>
          <h2 className={styles.containerTitle}>{t("section4.title")}</h2>
          {children || <p className={styles.containerDesc}>{t("section4.description")}</p>}
          <PricingOfferButton className={styles.demoButton} source="book-a-demo-section" />
        </div>
      </div>
    </SectionWrapper>
  );
}
